export default function FormSection() {
	return (
		<section className="w-full bg-white py-16 px-6">
			{/* Título */}
			<div className="w-full max-w-3xl mx-auto border-b border-[#cbbca3]/40 pb-6 mb-12">
				<h2 className="text-[#cbbca3] text-4xl md:text-5xl font-bold text-center">
					Tu opinión es importante
				</h2>
			</div>

			{/* Formulario */}
			<div className="w-full max-w-3xl mx-auto flex flex-col gap-6">
				<input
					className="w-full bg-gray-100 px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#cbbca3] transition"
					type="text"
					placeholder="Nombre"
				/>

				<input
					className="w-full bg-gray-100 px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#cbbca3] transition"
					type="text"
					placeholder="Lugar de procedencia"
				/>

				<div className="w-full flex flex-col md:flex-row md:items-center gap-4">
					<p className="text-gray-700 font-medium">Calidad de servicio:</p>

					<select
						name="select"
						className="bg-gray-100 px-4 py-3 rounded-md w-full md:w-64 focus:outline-none focus:ring-2 focus:ring-[#cbbca3] transition"
					>
						<option value="1">Muy buena</option>
						<option value="2">Buena</option>
						<option value="3">Regular</option>
						<option value="4">Mala</option>
					</select>
				</div>

				<input
					type="text"
					placeholder="Puesto"
					className="w-full bg-gray-100 px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#cbbca3] transition"
				/>

				<textarea
					placeholder="Escribe tus comentarios y el servicio que solicitaste"
					className="w-full bg-gray-100 px-4 py-3 h-32 rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-[#cbbca3] transition"
				/>

				<button className="w-full py-3 bg-[#0a1633] text-[#cbbca3] font-semibold rounded-md hover:bg-[#0f204b] transition">
					Publicar
				</button>
			</div>
		</section>
	);
}
